import { message } from "antd";
import axios from "axios";
import { getJwt } from "../../utils/authStorage";

// Set REACT_APP_BE_URL in the Render dashboard (Environment tab) to the deployed
// backend's URL. Falls back to the local backend for `npm start` during development.
axios.defaults.baseURL = process.env.REACT_APP_BE_URL || "http://localhost:3003";
const API_KEY = process.env.REACT_APP_API_KEY
axios.interceptors.request.use(config => {
  // Add the API key to the headers of every request
  config.headers['x-api-key'] = API_KEY;
  return config;
}, error => {
  return Promise.reject(error);
});


export const insertData = async () => {
  await axios.get("/api/insert-car");
  message.success("Auto přidáno!");
};

export const getCars = async (filter) => {

  const response = await axios.get("/api/get-cars", {
    params: {
      filter: filter
    }
  });
  return response;
};

export const getCar = async (id) => {
  const response = await axios.get(`/api/get-car/${id}`);
  return response;
};

export const getImages = async (carPhotoLink) => {
  const response = await axios.get(`/api/images/${carPhotoLink}`);
  return response;
};

export const getAllImages = async (id) => {
  const response = await axios.get(`/api/get-all-images/${id}`);
  console.log(response);
  return response;
}

export const getProducers = async () => {
  const response = await axios.get("/api/get-producers");
  console.log(response);
  return response;
}

export const deleteCar = async (id) => {
  const response = await axios.delete(`/api/delete-car/${id}`, {
    headers: {
      Authorization: `Bearer ${getJwt()}`
    }
  });
  console.log(response);
  message.success("Auto smazano!");
}

export const login = async (values) => {
  const response = await axios.get("/api/login", {params:values});
  console.log(response);
  return response;
}

export const desktopAutoLogin = async () => {
  const response = await axios.get("/api/desktop-auto-login");
  return response;
}

export const sendMail = async (formFields) => {
  console.log(formFields)
  const response = await axios.post("/api/send-mail", formFields, {
    headers: {
      'Content-Type': 'application/json'
    }
  }
  )
  console.log(response)
  return response
}

export const parseXmlFile = async () => {
  try {
    const response = await axios.get("/api/trigger-parser", {
    });
    console.log(response);
    return response;
  } catch (error) {
    console.log(error)
    if (error.response.status === 429) {
      message.error("Jedno nahravaní jiz probiha, zkuste to prosím později.");
      return error;
    } else {
      console.error("Error parsing XML file:", error);
      message.error("Chyba při načítání souboru. Soubor byl pravděpodobně poškozen nebo neexistuje.");
      throw error;
    }
  }
}

export const deleteAllCars = async () => {
  const response = await axios.get("/api/delete-all-cars");
  console.log(response);
  return response;
}